// GEGENEREERD door scripts/audio-library.mjs; niet met de hand wijzigen.
// Opnamebibliotheek (golf 6b, DESIGN §8.GB.15, docs/LICENSES.md): per opname de bron, de maker,
// de licentie (opnieuw gecontroleerd op de bronpagina), de bewerking en de SHA-256 van het
// bestand dat de kiosk-origin serveert onder een neutrale naam (/a/<hash>.m4a).
export const LIBRARY_RECORDINGS = [
    {
        id: 'lib_mecca',
        region: 'hijaz',
        place: 'mecca',
        year: 2013,
        fajr: 'no',
        tradition: 'sunni',
        title: 'Adhan, Great Mosque of Mecca - Jan 21, 2013',
        author: 'Seyfula Islam',
        platform: 'Wikimedia Commons',
        page: 'https://commons.wikimedia.org/wiki/File:Adhan,_Great_Mosque_of_Mecca_-_Jan_21,_2013.webm',
        file: 'https://upload.wikimedia.org/wikipedia/commons/a/a7/Adhan%2C_Great_Mosque_of_Mecca_-_Jan_21%2C_2013.webm',
        sourceSha1: '818becd553dde887095641bd1c86549db44060bc',
        license: 'CC-BY-3.0',
        licenseUrl: 'https://creativecommons.org/licenses/by/3.0/',
        outputLicense: 'CC-BY-3.0',
        shareAlike: false,
        modified: 'Ingekort (7 s vanaf het begin, 191 s), highpass 70 Hz, luidheid −16 LUFS (gemeten -16.7), AAC mono 64 kbit/s',
        retrieved: '2026-09-26',
        note: 'Van een YouTube-upload "AZAAN in makkah" (CC BY, via Wikimedia Commons); plek en opnamewijze niet bevestigd, de muezzin wordt niet genoemd.',
        durationS: 190,
        asset: {
            path: '/a/ec2d78cb01343fdf.m4a',
            sha256: 'ec2d78cb01343fdfc80a97ee6b48f060fb79af4918fd727c8305c4fb18955de2',
            bytes: 1565036,
        },
    },
    {
        id: 'lib_istanbul',
        region: 'turkish',
        place: 'istanbul',
        year: 2025,
        fajr: 'no',
        tradition: 'sunni',
        title: 'Adhan in Istanbul',
        author: 'Viceskeeni2',
        platform: 'Wikimedia Commons',
        page: 'https://commons.wikimedia.org/wiki/File:Adhan_in_Istanbul.webm',
        file: 'https://upload.wikimedia.org/wikipedia/commons/3/3d/Adhan_in_Istanbul.webm',
        sourceSha1: '15ea3b39550146a4b18a8d7debadb99f3ea7b5e2',
        license: 'CC0-1.0',
        licenseUrl: 'https://creativecommons.org/publicdomain/zero/1.0/',
        outputLicense: 'CC0-1.0',
        shareAlike: false,
        modified: 'Ingekort (0 s vanaf het begin, 51 s), highpass 70 Hz, luidheid −16 LUFS (gemeten -17.6), AAC mono 64 kbit/s',
        retrieved: '2026-09-26',
        note: 'Kort (± 50 s).',
        durationS: 50,
        asset: {
            path: '/a/d918059188f0df35.m4a',
            sha256: 'd918059188f0df35b675ebee0b441e3cef783b847327d6d26b9bc6180b5779f7',
            bytes: 412934,
        },
    },
    {
        id: 'lib_kalenderhane',
        region: 'turkish',
        place: 'istanbul_fatih',
        year: 2010,
        fajr: 'no',
        tradition: 'sunni',
        title: 'Muezzin of Kalenderhane Camii, Slowing down the rush',
        author: 'Adi W (radio aporee)',
        platform: 'archive.org',
        page: 'https://archive.org/details/aporee_8479_10269',
        file: 'https://archive.org/download/aporee_8479_10269/kalenderhane.mp3',
        sourceSha1: '7a0c398f1095642146e4c543d760017310972ad8',
        license: 'CC-BY-SA-3.0',
        licenseUrl: 'https://creativecommons.org/licenses/by-sa/3.0/',
        outputLicense: 'CC-BY-SA-3.0',
        shareAlike: true,
        modified: 'Ingekort (3 s vanaf het begin, 246 s), highpass 70 Hz, luidheid −16 LUFS (gemeten -17.0), AAC mono 64 kbit/s',
        retrieved: '2026-09-26',
        note: 'İkindi (middag), langzaam en rustig.',
        durationS: 246,
        asset: {
            path: '/a/dc191c3bafa4f6d6.m4a',
            sha256: 'dc191c3bafa4f6d6641d360bf94c8f83909d98b13c0cfe01f4a867702cda66a1',
            bytes: 2032149,
        },
    },
    {
        id: 'lib_mardin',
        region: 'turkish',
        place: 'mardin',
        year: 2012,
        fajr: 'unverified',
        tradition: 'sunni',
        title: 'mardin_ezan_emrahddd.wav',
        author: 'emrahddd',
        platform: 'Freesound',
        page: 'https://freesound.org/people/emrahddd/sounds/168652/',
        file: 'https://cdn.freesound.org/previews/168/168652_207597-hq.mp3',
        sourceSha1: '1d4f0b758c15e8e18acb5f3f69ef5b0b85da7cbd',
        license: 'CC0-1.0',
        licenseUrl: 'https://creativecommons.org/publicdomain/zero/1.0/',
        outputLicense: 'CC0-1.0',
        shareAlike: false,
        modified: 'Ingekort (2 s vanaf het begin, 347 s), highpass 70 Hz, luidheid −16 LUFS (gemeten -16.0), AAC mono 64 kbit/s',
        retrieved: '2026-09-26',
        note: 'Sabah ezanı. Alleen deze versie (CC0); het origineel van dezelfde maker is BY-NC.',
        durationS: 347,
        asset: {
            path: '/a/6c440f1e32e596c4.m4a',
            sha256: '6c440f1e32e596c462fa9bd76032e02a253a5235893359bc2e65bdd438a22686',
            bytes: 2858804,
        },
    },
    {
        id: 'lib_patara',
        region: 'turkish',
        place: 'patara',
        year: 1992,
        fajr: 'unverified',
        tradition: 'sunni',
        title: 'patara-ezan.wav',
        author: 'sazman',
        platform: 'Freesound',
        page: 'https://freesound.org/people/sazman/sounds/28775/',
        file: 'https://cdn.freesound.org/previews/28/28775_5726-hq.mp3',
        sourceSha1: '9c36a466e96b7562dac96ab662c1547b4e80cc54',
        license: 'CC-BY-4.0',
        licenseUrl: 'https://creativecommons.org/licenses/by/4.0/',
        outputLicense: 'CC-BY-4.0',
        shareAlike: false,
        modified: 'Ingekort (0 s vanaf het begin, 397 s), highpass 70 Hz, luidheid −16 LUFS (gemeten -20.1), AAC mono 64 kbit/s',
        retrieved: '2026-09-26',
        note: 'Dorp in Zuidwest-Turkije, 1992, de eerste ezan van de dag; krekels op de achtergrond.',
        durationS: 397,
        asset: {
            path: '/a/da05d0f98d98d394.m4a',
            sha256: 'da05d0f98d98d394edca9fb87b32c599ab75bb2a67629911b40156bd4975f7ea',
            bytes: 3310565,
        },
    },
    {
        id: 'lib_casablanca',
        region: 'maghreb',
        place: 'casablanca',
        year: 2019,
        fajr: 'no',
        tradition: 'sunni',
        title: 'Llamada a oración Mezquita Hassan II',
        author: 'Fraguando',
        platform: 'Wikimedia Commons',
        page: 'https://commons.wikimedia.org/wiki/File:Llamada_a_oraci%C3%B3n_Mezquita_Hassan_II.wav',
        file: 'https://upload.wikimedia.org/wikipedia/commons/9/9c/Llamada_a_oraci%C3%B3n_Mezquita_Hassan_II.wav',
        sourceSha1: '6e13b5302083b86cce0427f4c4509b9135232739',
        license: 'CC-BY-SA-4.0',
        licenseUrl: 'https://creativecommons.org/licenses/by-sa/4.0/',
        outputLicense: 'CC-BY-SA-4.0',
        shareAlike: true,
        modified: 'Ingekort (2 s vanaf het begin, 173 s), highpass 70 Hz, luidheid −16 LUFS (gemeten -18.8), AAC mono 64 kbit/s',
        retrieved: '2026-09-26',
        note: 'Hassan II-moskee.',
        durationS: 173,
        asset: {
            path: '/a/bcddfb961fc5730c.m4a',
            sha256: 'bcddfb961fc5730cfd28b8161027f1417a407cb4e44ed10ea505933e9e868387',
            bytes: 1429206,
        },
    },
    {
        id: 'lib_marrakech',
        region: 'maghreb',
        place: 'marrakech',
        year: 2021,
        fajr: 'no',
        tradition: 'sunni',
        title: 'Call Of Prayer - ADHAN - Marrakech.WAV',
        author: 'Redalemage',
        platform: 'Freesound',
        page: 'https://freesound.org/people/Redalemage/sounds/583206/',
        file: 'https://cdn.freesound.org/previews/583/583206_7145976-hq.mp3',
        sourceSha1: 'b8d40d16672dc62290794af608b363247cf749ca',
        license: 'CC0-1.0',
        licenseUrl: 'https://creativecommons.org/publicdomain/zero/1.0/',
        outputLicense: 'CC0-1.0',
        shareAlike: false,
        modified: 'Ingekort (0 s vanaf het begin, 186 s), highpass 70 Hz, luidheid −16 LUFS (gemeten -17.3), AAC mono 64 kbit/s',
        retrieved: '2026-09-26',
        note: 'Maghrib, opgenomen op het plein Jemaa el-Fna (veel stadsgeluid).',
        durationS: 186,
        asset: {
            path: '/a/32e46c0f8ef253dc.m4a',
            sha256: '32e46c0f8ef253dcbd58088438e89b7eaa407e03c2aefbc925dc5570cd290545',
            bytes: 1529786,
        },
    },
    {
        id: 'lib_marrakech_dawn',
        region: 'maghreb',
        place: 'marrakech_medina',
        year: 2014,
        fajr: 'unverified',
        tradition: 'sunni',
        title: 'extract azan dawn binaural medina marrakesh.wav',
        author: 'aifoon',
        platform: 'Freesound',
        page: 'https://freesound.org/people/aifoon/sounds/277335/',
        file: 'https://cdn.freesound.org/previews/277/277335_1453828-hq.mp3',
        sourceSha1: '14d9dddcb776846ff98fd3c240d69194e99d89d5',
        license: 'CC-BY-3.0',
        licenseUrl: 'https://creativecommons.org/licenses/by/3.0/',
        outputLicense: 'CC-BY-3.0',
        shareAlike: false,
        modified: 'Ingekort (15 s vanaf het begin, 237 s), highpass 70 Hz, luidheid −16 LUFS (gemeten -18.9), AAC mono 64 kbit/s',
        retrieved: '2026-09-26',
        note: 'Ochtend, in de medina van Marrakech (binauraal).',
        durationS: 237,
        asset: {
            path: '/a/77dcea76c1adcbaa.m4a',
            sha256: '77dcea76c1adcbaa8eef333f5ad7ecbdc9e1421b0408907ef78e645ffb78a471',
            bytes: 1961344,
        },
    },
    {
        id: 'lib_quseir',
        region: 'egypt',
        place: 'quseir',
        year: 2018,
        fajr: 'no',
        tradition: 'sunni',
        title: 'Adhan in Qusser by the sea.mp3',
        author: 'AhmadAiuby',
        platform: 'Freesound',
        page: 'https://freesound.org/people/AhmadAiuby/sounds/555065/',
        file: 'https://cdn.freesound.org/previews/555/555065_8105512-hq.mp3',
        sourceSha1: '211032cdb794ccf4011d86faf75245f96f803f91',
        license: 'CC0-1.0',
        licenseUrl: 'https://creativecommons.org/publicdomain/zero/1.0/',
        outputLicense: 'CC0-1.0',
        shareAlike: false,
        modified: 'Ingekort (4 s vanaf het begin, 123 s), highpass 70 Hz, luidheid −16 LUFS (gemeten -16.6), AAC mono 64 kbit/s',
        retrieved: '2026-09-26',
        note: 'Veldopname aan zee in El Quseir.',
        durationS: 123,
        asset: {
            path: '/a/5237af60fb1481d2.m4a',
            sha256: '5237af60fb1481d2370c426044f79ae1ced0b55dd42e395313032e14f63c54b6',
            bytes: 1011277,
        },
    },
    {
        id: 'lib_amman',
        region: 'levant',
        place: 'amman',
        year: 2023,
        fajr: 'unverified',
        tradition: 'sunni',
        title: 'Mohammad and Mahera Abu Ghazaleh Foundation for Art & Culture - Recording of first azan',
        author: 'Eric Desjeux (radio aporee)',
        platform: 'archive.org',
        page: 'https://archive.org/details/aporee_66016_76323',
        file: 'https://archive.org/download/aporee_66016_76323/MORNINGAZANBIRDSAMMANFEB23.mp3',
        sourceSha1: '20cd903ed005290703749ab53a82940c13fada37',
        license: 'CC-BY-3.0',
        licenseUrl: 'https://creativecommons.org/licenses/by/3.0/',
        outputLicense: 'CC-BY-3.0',
        shareAlike: false,
        modified: 'Ingekort (0 s vanaf het begin, 254 s), highpass 70 Hz, luidheid −16 LUFS (gemeten -16.1), AAC mono 64 kbit/s',
        retrieved: '2026-09-26',
        note: 'De eerste azan van de ochtend, met vogels.',
        durationS: 254,
        asset: {
            path: '/a/3242c1874d734470.m4a',
            sha256: '3242c1874d73447086c9d6d6251bd353945882a3ede67e7589d8be134c1a982b',
            bytes: 2091304,
        },
    },
    {
        id: 'lib_kualalumpur',
        region: 'southeast_asia',
        place: 'kuala_lumpur',
        year: 2025,
        fajr: 'unverified',
        tradition: 'sunni',
        title: 'Early morning adhan Balakong Kuala Lumpur Jan25',
        author: 'aridtrax',
        platform: 'Freesound',
        page: 'https://freesound.org/people/aridtrax/sounds/863861/',
        file: 'https://cdn.freesound.org/previews/863/863861_851389-hq.mp3',
        sourceSha1: '227108b4ca14eb1d2d7a20c5ce481475ef43ce79',
        license: 'CC0-1.0',
        licenseUrl: 'https://creativecommons.org/publicdomain/zero/1.0/',
        outputLicense: 'CC0-1.0',
        shareAlike: false,
        modified: 'Ingekort (0 s vanaf het begin, 274 s), highpass 70 Hz, luidheid −16 LUFS (gemeten -17.3), AAC mono 64 kbit/s',
        retrieved: '2026-09-26',
        note: 'Vroeg in de ochtend in een woonwijk; luide airco op de achtergrond.',
        durationS: 274,
        asset: {
            path: '/a/3679fc5a79fcb525.m4a',
            sha256: '3679fc5a79fcb52569fe17e88c075f174f20791f0eea5993c1184d19aaae5c12',
            bytes: 2247105,
        },
    },
    {
        id: 'lib_shalqar',
        region: 'central_asia',
        place: 'shalqar',
        year: 2014,
        fajr: 'no',
        tradition: 'sunni',
        title: 'Adhan in Shalqar mosque',
        author: 'Esetok',
        platform: 'Wikimedia Commons',
        page: 'https://commons.wikimedia.org/wiki/File:Adhan_in_Shalqar_mosque.webm',
        file: 'https://upload.wikimedia.org/wikipedia/commons/4/4f/Adhan_in_Shalqar_mosque.webm',
        sourceSha1: '5d7301c0c142d8e5d8f281f4dd02846eaf05529b',
        license: 'CC-BY-SA-4.0',
        licenseUrl: 'https://creativecommons.org/licenses/by-sa/4.0/',
        outputLicense: 'CC-BY-SA-4.0',
        shareAlike: true,
        modified: 'Ingekort (2 s vanaf het begin, 132 s), highpass 70 Hz, luidheid −16 LUFS (gemeten -18.0), AAC mono 64 kbit/s',
        retrieved: '2026-09-26',
        note: 'Shalqar, Kazachstan.',
        durationS: 132,
        asset: {
            path: '/a/d8486f49be8b7f0e.m4a',
            sha256: 'd8486f49be8b7f0e07726635dd719fc19c2603e8777625af8b209eca89df8663',
            bytes: 1087486,
        },
    },
    {
        id: 'lib_malmo',
        region: 'europe',
        place: 'malmo',
        year: 2012,
        fajr: 'unverified',
        tradition: 'sunni',
        title: 'Eid al-Fitr Fajr azan at Malmö Mosque - 19 August 2012',
        author: 'Islamic Center Malmö',
        platform: 'Wikimedia Commons',
        page: 'https://commons.wikimedia.org/wiki/File:Eid_al-Fitr_Fajr_azan_at_Malm%C3%B6_Mosque_-_19_August_2012.webm',
        file: 'https://upload.wikimedia.org/wikipedia/commons/b/b1/Eid_al-Fitr_Fajr_azan_at_Malm%C3%B6_Mosque_-_19_August_2012.webm',
        sourceSha1: 'bc75d5cee271efb67f03d3f35474a9362fce103f',
        license: 'CC-BY-3.0',
        licenseUrl: 'https://creativecommons.org/licenses/by/3.0/',
        outputLicense: 'CC-BY-3.0',
        shareAlike: false,
        modified: 'Ingekort (4 s vanaf het begin, 244 s), highpass 70 Hz, luidheid −16 LUFS (gemeten -16.2), AAC mono 64 kbit/s',
        retrieved: '2026-09-26',
        note: 'Fajr op het Suikerfeest, binnen opgenomen.',
        durationS: 244,
        asset: {
            path: '/a/d133baf348badf1b.m4a',
            sha256: 'd133baf348badf1b42c0da0e7e23860f7c13c055d92ab7f6a3363784e74fc0e2',
            bytes: 2003128,
        },
    },
    {
        id: 'lib_friday',
        // Fixer golf 6b r2: de bron (archive.org, account van de ICR-moskee) noemt geen plaats; dus niet
        // onder Europa maar onder Overig tot de plek van de moskee bevestigd is.
        region: 'other',
        place: 'indoor',
        year: 2024,
        fajr: 'no',
        tradition: 'sunni',
        title: 'ICR Friday Prayer 1st Adhan 17th May 2024 9th Dhul Qadah 1445 By Asim Javed',
        author: 'Asim Javed',
        platform: 'archive.org',
        page: 'https://archive.org/details/icr-friday-prayer-1st-adhan-17th-may-2024-9th-dhul-qadah-1445-by-asim-javed',
        file: 'https://archive.org/download/icr-friday-prayer-1st-adhan-17th-may-2024-9th-dhul-qadah-1445-by-asim-javed/ICR_Friday_Prayer_1st_Adhan_17th_May_2024_9th_Dhul_Qadah_1445_by_Asim_Javed.flac',
        sourceSha1: 'b2e95af4620579c1d2a7bee9d5182237132b17dc',
        license: 'CC0-1.0',
        licenseUrl: 'https://creativecommons.org/publicdomain/zero/1.0/',
        outputLicense: 'CC0-1.0',
        shareAlike: false,
        modified: 'Ingekort (0 s vanaf het begin, 220 s), highpass 70 Hz, luidheid −16 LUFS (gemeten -16.1), AAC mono 64 kbit/s',
        retrieved: '2026-09-26',
        note: 'Binnen opgenomen, schoon geluid; geüpload onder de naam Asim Javed (CC0).',
        durationS: 220,
        asset: {
            path: '/a/cf92211b42789d5f.m4a',
            sha256: 'cf92211b42789d5ffd57a09193076c24a44ca10d042a3087cdb0cdad8ea66c8d',
            bytes: 1814176,
        },
    },
];
//# sourceMappingURL=library.js.map